require("../../../static/js/bootstrap/bootstrap-notify.min.js");
require("../../../static/js/generic-promo-banner.js");
